var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 24.5V3.5H18V24.5H11V19.8333H8.66667V24.5H1.66667ZM4.00001 22.1667H6.33334V17.5H13.3333V22.1667H15.6667V5.83333H4.00001V22.1667ZM6.33334 15.1667H8.66667V12.8333H6.33334V15.1667ZM6.33334 10.5H8.66667V8.16667H6.33334V10.5ZM11 15.1667H13.3333V12.8333H11V15.1667ZM11 10.5H13.3333V8.16667H11V10.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 18.0833L24.8833 16.45L23.6292 15.1667H27.3333V12.8333H23.6292L24.8833 11.55L23.25 9.91666L19.1667 14L23.25 18.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpReturn);
export default __webpack_public_path__ + "static/media/IPReturn.ad44861a04049dbb39a7d4468e48780f.svg";
export { ForwardRef as ReactComponent };